export default function Hero() {
  const handleScrollTo = (href: string) => {
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20orange%20and%20deep%20crimson%20abstract%20gradient%20background%20with%20flowing%20curves%20and%20soft%20geometric%20shapes%2C%20cinematic%20atmosphere%2C%20modern%20streaming%20platform%20aesthetic%2C%20dark%20edges%20with%20warm%20center%20glow%2C%20smooth%20texture%2C%20no%20text%2C%20abstract%20digital%20art%20style&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
          loading="eager"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-semibold rounded-full bg-primary-500/20 text-primary-300 border border-primary-500/30 mb-5 whitespace-nowrap">
              全网热门视频聚合平台
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-background-50 leading-tight mb-4">
              桔子视频<span className="text-primary-400"> · </span>聚合全网热门视频平台
            </h1>

            <p className="text-lg md:text-xl text-background-200/90 font-medium mb-5">
              红桃视频 · 樱桃视频 · 茄子视频 · 糖心视频 同步收录
            </p>

            <p className="text-sm md:text-base text-background-300/80 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-7">
              桔子视频致力于聚合全网优质视频平台内容，涵盖红桃视频、樱桃视频、茄子视频、糖心视频等热门站点，
              提供免费在线观看高清电视剧全集服务。每日同步更新最新资源，不缓冲流畅播放，
              更有热门短剧、综艺娱乐、影视大片等海量内容持续上新，让精彩视频一网打尽。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-primary-500/20 flex items-center justify-center">
                  <i className="ri-refresh-line text-primary-400 text-sm"></i>
                </div>
                <span className="text-sm text-background-200/80">每日同步更新</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-500/20 flex items-center justify-center">
                  <i className="ri-flashlight-line text-accent-400 text-sm"></i>
                </div>
                <span className="text-sm text-background-200/80">不缓冲流畅播</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-secondary-500/20 flex items-center justify-center">
                  <i className="ri-shield-check-line text-secondary-400 text-sm"></i>
                </div>
                <span className="text-sm text-background-200/80">多平台安全收录</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => handleScrollTo('#index')}
                className="w-full sm:w-auto px-8 py-3.5 text-base font-bold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                立即浏览专题
              </button>
              <button
                onClick={() => handleScrollTo('#ranking')}
                className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold rounded-full border-2 border-background-50/30 text-background-50 hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                查看热度榜单
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-background-900/40 border border-background-50/10">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20video%20streaming%20platform%20interface%20mockup%20with%20multiple%20video%20thumbnail%20cards%20in%20a%20grid%20layout%2C%20warm%20orange%20and%20dark%20theme%2C%20cinematic%20posters%2C%20clean%20UI%20design%2C%20sleek%20and%20modern%20entertainment%20platform%20aesthetic%2C%20soft%20lighting%2C%20professional%20digital%20product%20showcase&width=960&height=720&seq=hero-visual-2026&orientation=landscape"
                  alt="桔子视频平台界面展示"
                  className="w-full h-full object-cover"
                  loading="eager"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 md:w-28 md:h-28 rounded-2xl bg-primary-500/90 flex flex-col items-center justify-center border-2 border-background-50/20">
                <span className="text-2xl md:text-3xl font-black text-background-50">99+</span>
                <span className="text-xs text-background-50/90">热门平台</span>
              </div>
              <div className="absolute -top-4 -left-4 w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-accent-500/90 flex flex-col items-center justify-center border-2 border-background-50/20">
                <span className="text-xl md:text-2xl font-black text-background-50">24h</span>
                <span className="text-xs text-background-50/90">持续更新</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}